import React, { ReactNode } from "react";
import type { IconComponent } from "../../types/ui";
interface CardProps {
  title?: string;
  subtitle?: string;
  icon?: IconComponent;
  action?: ReactNode;
  children: ReactNode;
  className?: string;
  bodyClassName?: string;
}
export function Card({
  title,
  subtitle,
  icon: Icon,
  action,
  children,
  className = '',
  bodyClassName = 'px-6 pb-6'
}: CardProps) {
  return <section className={`rounded-2xl bg-white shadow-soft ring-1 ring-slate-900/[0.04] ${className}`} data-id="element-745" data-mp="h4rzjjytms72">
      {title && <header className="flex items-start justify-between gap-4 px-6 pb-4 pt-5" data-id="element-746" data-mp="m2bmd89l4dam">
          <div className="flex min-w-0 items-center gap-3" data-id="element-747" data-mp="r1wi79tgk5j4">
            {Icon && <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-xl bg-navy/[0.05] text-navy" data-id="element-748" data-mp="r0lefa00ixs0">
                <Icon className="h-[18px] w-[18px]" aria-hidden="true" data-id="element-749" data-mp="2sucee7wnuhvm" />
              </span>}
            <div className="min-w-0" data-id="element-750" data-mp="2xsm9yjmarkhr">
              <h2 className="truncate text-[15px] font-semibold text-navy" data-id="element-751" data-mp="2xtozoo7vvgw3">{title}</h2>
              {subtitle && <p className="mt-0.5 truncate text-xs text-muted" data-id="element-752" data-mp="2zhv0d1ioord4">{subtitle}</p>}
            </div>
          </div>
          {action && <div className="flex shrink-0 items-center gap-2" data-id="element-753" data-mp="2up1xkj6rzt3o">{action}</div>}
        </header>}
      <div className={bodyClassName} data-id="element-754" data-mp="2prtg6ktgbt3h">{children}</div>
    </section>;
}